// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eZvQ","col":"styles_col__1_2ks"};